
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Créer un site Internet de couvreur : exemples, prix et délais",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Un couvreur professionnel doit intégrer le digital dans sa stratégie de communication. Cela passe notamment par la création d’un site Internet de qualité.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Créer un site Internet de couvreur : exemples, prix et délais",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Un couvreur professionnel doit intégrer le digital dans sa stratégie de communication. Cela passe notamment par la création d’un site Internet de qualité.",
        },
      ],
    };
  },
};
